import { CancelTokenSource } from 'axios';
import { FilterSet } from '../user-preferences-v2/types';
import { ParserOutput } from '../../entities/message-parser-v1/parsed-response';
import { TransactionType } from '../../entities/transactions-v1/query-types';

export enum transactionsActionNames {
  SET_TRANSACTIONS = 'SET_TRANSACTIONS',
  SET_TOTAL_COUNT = 'SET_TOTAL_COUNT',
  CLEAR_TRANSACTIONS = 'CLEAR_TRANSACTIONS',
  SET_ACTIVE_FILTERS = 'SET_ACTIVE_FILTERS',
  SET_CURRENTLY_EDITING_FILTER = 'SET_CURRENTLY_EDITING_FILTER',
  SET_EXPORT_TRANSACTION = 'SET_EXPORT_TRANSACTION',
  SET_PARSED_MESSAGE = 'SET_PARSED_MESSAGE',
  TOGGLE_APPLIED_FILE_TYPE_FILTERS = 'TOGGLE_APPLIED_FILE_TYPE_FILTERS',
  CLEAR_APPLIED_FILE_TYPE_FILTERS = 'CLEAR_APPLIED_FILE_TYPE_FILTERS',
  SET_EXPORTABLE = 'SET_EXPORTABLE',
  SET_ALL_FILE_TYPES = 'SET_ALL_FILE_TYPES',
  SET_AJAX_REQUEST_FOR_CANCEL_TOKEN = 'SET_AJAX_REQUEST_FOR_CANCEL_TOKEN',
  SET_DETAILS = 'SET_DETAILS',
  CLEAR_DETAILS = 'CLEAR_DETAILS',
  SET_SUBCOMPONENT_RENDERRING_FLAG = 'SET_SUBCOMPONENT_RENDERRING_FLAG',
  SET_LOADING_FLAG = 'SET_LOADING_FLAG',
}

export type Transaction = {
  deviceId?: string;
  index?: string;
  deviceType?: string;
  fileTypeId?: string;
  fileName?: string;
  fileTypeName?: string;
  gatewayReceiptTime?: string;
  id?: string;
  key?: string;
  lastUpdateTime?: string;
  lastUpdatedBy?: string;
  messageCreationTime?: string;
  status?: string;
  transactionType?: string;
  replays?: { replayCount: number; replayUserId: string };
  routes?: { downstreamSystem: string; sentTime: string };
  parsedMessage?: ParserOutput[];
  messageDetail?: any;
};

export type Details = {
  recordId: string;
  expandedIds: Array<number>;
};

export interface FileType {
  fileTypeName: string;
  fileTypeId: string;
  type: string;
}

export interface TransactionsState {
  count: number;
  downloadSuccess?: boolean;
  exportable: boolean;
  allFileTypes: FileType[];
  ajaxRequestCancelTokenForCount: CancelTokenSource | null;
  detailsExpanded: Array<Details>;
  subComponentRenderringFlag: boolean;
  loadingFlag: boolean;
}

interface SetExportTransactionUrlAction {
  type: typeof transactionsActionNames.SET_EXPORT_TRANSACTION;
  payload: boolean;
}
interface SetSubcomponenetRenderringFlag {
  type: typeof transactionsActionNames.SET_SUBCOMPONENT_RENDERRING_FLAG;
  payload: boolean;
}
interface SetTotalCount {
  type: typeof transactionsActionNames.SET_TOTAL_COUNT;
  payload: number;
}

interface ClearTransaction {
  type: typeof transactionsActionNames.CLEAR_TRANSACTIONS;
}

interface SetActiveFilters {
  type: typeof transactionsActionNames.SET_ACTIVE_FILTERS;
  payload: FilterSet[];
}

interface SetCurrentlyEditingFilter {
  type: typeof transactionsActionNames.SET_CURRENTLY_EDITING_FILTER;
  payload: number | undefined;
}

interface ToggleAppliedFileTypeFilters {
  type: typeof transactionsActionNames.TOGGLE_APPLIED_FILE_TYPE_FILTERS;
  payload: TransactionType[];
}

interface ClearAppliedFileTypeFilters {
  type: typeof transactionsActionNames.CLEAR_APPLIED_FILE_TYPE_FILTERS;
  payload: [];
}

interface SetExportable {
  type: typeof transactionsActionNames.SET_EXPORTABLE;
  payload: boolean;
}

interface SetAllFileTypes {
  type: typeof transactionsActionNames.SET_ALL_FILE_TYPES;
  payload: FileType[] | [];
}

interface SetAjaxRequest {
  type: typeof transactionsActionNames.SET_AJAX_REQUEST_FOR_CANCEL_TOKEN;
  payload: CancelTokenSource;
}

interface SetDetails {
  type: typeof transactionsActionNames.SET_DETAILS;
  payload: Details[];
}
interface ClearDetails {
  type: typeof transactionsActionNames.CLEAR_DETAILS;
}
interface SetLoadingFlag {
  type: typeof transactionsActionNames.SET_LOADING_FLAG;
  payload: boolean;
}
export type TransactionsActionTypes =
  | SetTotalCount
  | ClearTransaction
  | SetActiveFilters
  | SetCurrentlyEditingFilter
  | SetExportTransactionUrlAction
  | ToggleAppliedFileTypeFilters
  | ClearAppliedFileTypeFilters
  | SetExportable
  | SetAllFileTypes
  | SetAjaxRequest
  | SetDetails
  | ClearDetails
  | SetSubcomponenetRenderringFlag
  | SetLoadingFlag;
